import React from "react";
import {Formik} from "formik";
import {validator} from "@reside/forms";
import Alert from "react-s-alert";
import {
  H1,
  Button,
  Modal,
  ModalContent,
  ModalFooterButtons,
  Box,
  SelectField,
  CheckboxItem,
} from "@reside/ui";

import {useEditFacilityModalContext} from "../../../../atoms/edit-facility-confirmation-modal";
import {useTemplateNamesQuery} from "../../../page-admin-hub-and-spoke/hooks/useTemplateNamesQuery";
import {useFacilitySettingsParams} from "../../hooks/useFacilitySettingsParams";
import {buildResponseErrorMessage} from "../../../../services/api/errorHelpers";
import {UpdateFacilityTemplateModel} from "../../../../utils/types/facility";
import {BackdropSpinner} from "../../../../atoms/spinner";

type Props = Readonly<{
  isOpen: boolean;
  onClose: () => void;
  templateName: string;
}>;

export const ChangeTemplateModal = ({isOpen, onClose, templateName}: Props) => {
  const {facilityId} = useFacilitySettingsParams();
  const {toggle} = useEditFacilityModalContext();

  const {data: templateNames = [], isFetching} = useTemplateNamesQuery({
    onError: async (response: any) => {
      Alert.error(
        await buildResponseErrorMessage(
          response,
          "Unable to load template names",
        ),
      );
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title="Change Facility Template"
    >
      {({closeModal}) => (
        <BackdropSpinner active={isFetching}>
          <Formik<UpdateFacilityTemplateModel>
            initialValues={{templateName, migrateAdmissions: true}}
            validate={values =>
              validator.validateAll(values, {templateName: "required"})
            }
            onSubmit={fields => {
              toggle(facilityId, fields);
              closeModal();
            }}
          >
            {({values, setFieldValue, submitForm}) => (
              <>
                <ModalContent>
                  <SelectField
                    label="Facility Template"
                    name="templateName"
                    options={templateNames}
                    getOptionLabel={value => value}
                    getOptionValue={value => value}
                  />
                  <br />
                  <CheckboxItem
                    name="migrateAdmissions"
                    onChange={() =>
                      setFieldValue(
                        "migrateAdmissions",
                        !values.migrateAdmissions,
                      )
                    }
                    checked={values.migrateAdmissions}
                    label="Migrate preflight admissions to the new template?"
                  />
                </ModalContent>
                <ModalFooterButtons>
                  <Button outline color="primary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button
                    color="success"
                    onClick={submitForm}
                    disabled={values.templateName === templateName}
                  >
                    Save
                  </Button>
                </ModalFooterButtons>
              </>
            )}
          </Formik>
        </BackdropSpinner>
      )}
    </Modal>
  );
};
